/**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {HTMLElement} element
 * @param {T} newTagName
 * @returns {HTMLElementTagNameMap[T]}
 */
export function changeElementType(element, newTagName) {
  const newElement = document.createElement(newTagName);

  for (const {name, value} of element.attributes) {
    newElement.setAttribute(name, value);
  }

  newElement.append(...Array.from(element.childNodes));
  element.replaceWith(newElement);

  return newElement;
}